<script setup lang="ts">
import BBtn from '@lib/components/base/BBtn.vue'
import { useI18n } from 'vue-i18n'

defineEmits<{ (e: 'add'): void }>()
const { t } = useI18n()
</script>

<template>
    <BBtn severity="secondary" @click="$emit('add')">
        {{ t('clipboard.addPage') }}
    </BBtn>
</template>
